export const setPivot = (payload) => {
    return {
        type: 'SET_PIVOT',
        payload: payload
    }
};
